import React from "react";
import "../Company/Company.css";
import { FaBoxOpen, FaClipboardCheck } from "react-icons/fa";
import {
  TbArrowBigRightLinesFilled,
  TbArrowBigLeftLinesFilled,
} from "react-icons/tb";

const CompanySection = () => {
  return (
    <div className="container-cc">
      <div className="left-div-cc">
        <div className="left-content-cc" data-aos="fade-right">
          <div className="image-wrapper-cc">
            <img
              src="p.webp" // Replace with your first image URL
              alt="Packaging Sample 1"
              className="main-image-cc"
            />
            <img
              src="secondary.webp" // Replace with your second image URL
              alt="Packaging Sample 2"
              className="secondary-image-cc"
            />
          </div>
        </div>
      </div>
      <div className="right-div-cc">
        <p className="subheading-cc" data-aos="fade-left">
          About Company
        </p>
        <h1 className="main-heading-cc" data-aos="fade-left">
          Innovative Packaging for Orthopedic Instruments
        </h1>
        <p className="description-cc" data-aos="fade-left">
          We specialize in designing and developing high-quality, sterile, and
          user-friendly packaging solutions tailored for orthopedic surgical
          instruments.
        </p>
        <div className="icon-text-container-cc" data-aos="fade-left">
          <div className="icon-wrapper-cc">
            <FaBoxOpen className="react-icon-cc" />{" "}
            {/* Icon for Packaging Design */}
          </div>
          <div className="text-wrapper-cc">
            <h4 className="icon-heading-cc">Custom Packaging Design</h4>
            <p className="icon-description-cc">
              Delivering precise and durable packaging concepts that ensure
              safety, sterility, and brand identity.
            </p>
          </div>
        </div>
        <div className="icon-text-container-cc" data-aos="fade-left">
          <div className="icon-wrapper-cc">
            <FaClipboardCheck className="react-icon-cc" />{" "}
            {/* Icon for Quality & Compliance */}
          </div>
          <div className="text-wrapper-cc">
            <h4 className="icon-heading-cc">Production & Compliance</h4>
            <p className="icon-description-cc">
              From concept to compliant production, we ensure every packaging
              meets international medical standards and logistics efficiency.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CompanySection;
